import { CloseModal } from './../action-creators';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Action } from 'redux';
import { LOCATION_CHANGE } from 'connected-react-router';

export const closeMenusEpic = (action$: Observable<Action>): Observable<CloseModal> =>
  action$.pipe(
    ofType(LOCATION_CHANGE),
    map(() => new CloseModal('ALL'))
  );
